const isTheSignActor = (userId, report, formType, actorType) => {
  let trainingPhaseSignActors = report.trainingPhaseSignActor && report.trainingPhaseSignActor.find(sa => sa.type === formType);

  if (trainingPhaseSignActors && trainingPhaseSignActors[actorType]) {
    return trainingPhaseSignActors[actorType] === userId;
  }

  let signActors = report.signActors && report.signActors.find(sa => sa.type === formType);
  if (signActors && signActors[actorType]) {
    return signActors[actorType] === userId;
  } else {
    return true;
  }
};

const getSignActorForType = (report, formType, actorType) => {
  let trainingPhaseSignActors = report.trainingPhaseSignActor && report.trainingPhaseSignActor.find(sa => sa.type === formType);
  if (trainingPhaseSignActors && trainingPhaseSignActors[actorType]) {
    return trainingPhaseSignActors[actorType];
  }

  let signActors = report.signActors && report.signActors.find(sa => sa.type === formType);
  if (signActors && signActors[actorType]) {
    return signActors[actorType];
  } else {
    return null;
  }
}

export {
  isTheSignActor,
  getSignActorForType
}
